// extracted by mini-css-extract-plugin
export default {"colleague":"colleague____XhuZ","Steps":"Steps___R0UIk","content":"content___FIExa","text":"text___kcUhF"};